import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { TableSection, Pagination } from 'components';
import { useAPI, useDebounce } from 'hooks';
import { formatDate, getUserName } from 'helpers';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

const Test = () => {
  const { api } = useAPI();
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const debouncedSearchQuery = useDebounce(search, 1000);
  const itemsPerPage = 5;
  const limit = 30;

  const fetchParams = search.length > 0 ? { q: debouncedSearchQuery } : { limit };

  const { data: users } = useQuery({
    queryFn: api.list('user/', fetchParams),
    queryKey: ['user/', debouncedSearchQuery, limit],
    keepPreviousData: true,
  });

  const totalPages = users ? Math.ceil(users.length / itemsPerPage) : null;
  const startIndex = (page - 1) * itemsPerPage;
  const currentPageData = users ? users.slice(startIndex, startIndex + itemsPerPage) : [];

  const nextPage = () => setPage((p) => Math.min(p + 1, totalPages));
  const prevPage = () => setPage((p) => Math.max(p - 1, 1));

  const statusVariant = (isActive) =>
    isActive ? 'bg-green-100 text-green-800 border-green-300' : 'bg-red-100 text-red-700 border-red-300';

  return (
    <TableSection
      title="Liste des utilisateurs"
      description="Gérez les utilisateurs et leurs organisations"
      actionLabel="Ajouter un utilisateur"
      onSearch={(value) => setSearch(value.trim())}
      searchPlaceholder="Rechercher un utilisateur..."
    >
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Nom</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>Organisation(s)</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Création</TableHead>
            <TableHead>Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {currentPageData.map((user) => (
            <TableRow key={user.id}>
              <TableCell className="font-medium">{getUserName(user.first_name, user.last_name)}</TableCell>
              <TableCell>{user.email}</TableCell>
              {/* <TableCell className="space-x-2">
                {user.organizations.map((org) => (
                  <Badge key={org} variant="outline" className="rounded-full">
                    {org}
                  </Badge>
                ))}
              </TableCell> */}
              <TableCell className="space-x-2">
                <Badge key={user.organization_name} variant="outline" className="rounded-full">
                  {user.organization_name}
                </Badge>
              </TableCell>
              <TableCell>
                <Badge
                  variant="outline"
                  className={`${statusVariant(user.is_verified && user.is_active)} rounded-full`}
                >
                  {user.is_verified && user.is_active ? 'Actif' : 'Inactif'}
                </Badge>
              </TableCell>
              <TableCell>{formatDate(user.created)}</TableCell>
              <TableCell>
                <Button variant="outline" size="sm">
                  Editer
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* Pagination */}
      <Pagination page={page} totalPages={totalPages} onPrev={prevPage} onNext={nextPage} />
    </TableSection>
  );
};

export default Test;
